export default __webpack_public_path__ + "static/media/SCCC-Privacy-Policy-for-Customer-TH.7802e929.pdf";